import { useEffect, useState } from 'react';

/**
 * 偵測目前是否為手機尺寸（< lg 斷點 = 1024px）。
 * 用於切換元件版面（例如 StampToolbar 的橫向 / 直向）。
 * 不要用來控制純樣式 — 那些用 Tailwind `lg:` prefix 更好。
 */
export const useIsMobile = (breakpoint = 1024): boolean => {
    const query = `(max-width: ${breakpoint - 1}px)`;
    const getMatch = () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false);
    const [isMobile, setIsMobile] = useState<boolean>(getMatch);

    useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        // Safari < 14 仍只支援 addListener
        if (mql.addEventListener) mql.addEventListener('change', handler);
        else mql.addListener(handler);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', handler);
            else mql.removeListener(handler);
        };
    }, [query]);

    return isMobile;
};
